import React, { useState } from "react";
import { Input, User, Slider, Image, Link, Button, Checkbox } from "@nextui-org/react";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { signin } from "../../redux/actions";

const sliders = () => {
  const radius = ["full", "lg", "md", "sm", "none"];
  return (
    <div className="flex flex-col gap-6 w-full max-w-md">
      {radius.map((r) => (
        <Slider
          key={r}
          radius={r}
          step={0.01}
          maxValue={1}
          minValue={0}
          defaultValue={0.7}
          aria-label="Temperature"
          className="max-w-md"
        />
      ))}
    </div>
  );
};

const userProfile = () => (
  <User
    name="Jane Doe"
    description="Product Designer"
    avatarProps={{
      src: "https://i.pravatar.cc/150?u=a04258114e29026702d",
    }}
  />
);

const input = () => (
  <div className="flex w-full flex-wrap md:flex-nowrap gap-4">
    <Input
      type="email"
      label="Email"
    />
    <Input
      type="email"
      label="Email"
      placeholder="Enter your email"
    />
  </div>
);

const Login = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const toggleVisibility = () => setIsVisible(!isVisible);
  const [isSelected, setIsSelected] = React.useState(false);

  const handleOnSignin = async () => {
    if (!email || !password) {
      toast.warning(t("Please enter email and password"), { autoClose: 500 });
      return;
    }
    await dispatch(signin({ email, password }));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleOnSignin();
    }
  };

  const inputClassNames = {
    label: "text-sm text-gray-700 font-medium",
    inputWrapper: "border-1 border-gray-400",
    input: "placeholder:text-gray-300 placeholder:text-xs",
  };

  return (
    <div className="w-full flex flex-col items-start font-PlusJakartaSans">
      <h2 className="w-full text-2xl font-semibold text-gray-700">{t("Sign In")}</h2>
      <p className="w-full text-sm text-gray-400/70 mt-1 mb-10">
        {t("Enter your email and password to sign in!")}
      </p>
      <Input
        type="email"
        name="email"
        placeholder="mail@simmmple.com"
        label={t("Email")}
        labelPlacement="outside"
        isRequired
        variant="bordered"
        color="primary"
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={handleKeyPress}
        className="max-w-xs mb-6 rounded-md"
        classNames={inputClassNames}
      />
      <Input
        placeholder={t("Password")}
        name="password"
        label={t("Password")}
        labelPlacement="outside"
        isRequired
        variant="bordered"
        color="primary"
        endContent={
          <button
            className="focus:outline-none"
            type="button"
            onClick={toggleVisibility}
          >
            {isVisible ? (
              <IoEyeOutline
                size={20}
                className="text-2xl text-default-400 pointer-events-none"
              />
            ) : (
              <IoEyeOffOutline
                size={20}
                className="text-2xl text-default-400 pointer-events-none"
              />
            )}
          </button>
        }
        type={isVisible ? "text" : "password"}
        onChange={(e) => setPassword(e.target.value)}
        onKeyDown={handleKeyPress}
        className="max-w-xs mb-6 rounded-md"
        classNames={inputClassNames}
      />
      <div className="w-full max-w-xs flex justify-between items-center mb-6">
        <Checkbox
          color="primary"
          size="sm"
          radius="none"
          isSelected={isSelected}
          onValueChange={setIsSelected}
          classNames={{ label: "text-sm" }}
        >
          Keep me logged in
        </Checkbox>
        <Link
          href="/recovery"
          className="text-primary cursor-pointer text-sm"
        >
          {t("Reset Password?")}
        </Link>
      </div>
      <Button
        color="primary"
        className="w-full max-w-xs h-12"
        onPress={handleOnSignin}
      >
        {t("Sign In")}
      </Button>
    </div>
  );
};

export default Login;
